<template>
  <div v-if="decks.length" class="striped">
    <CompaniesDeckCarousel id="corporate-deck" class="container" :decks="decks">
      <template #title>
        <h2 class="tracking-normal font-semibold text-xl mb-0 lg_text-2xl">Investor 3D Presentations</h2>
      </template>
    </CompaniesDeckCarousel>
  </div>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import type { Deck } from '@/entities/deck'

defineProps({
  decks: {
    type: Array as PropType<DeepReadonly<Deck[]>>,
    default: () => [],
  },
})
</script>
